// assets/free-shipping.js
(function () {
  // --- helpers ---------------------------------------------------------------
  // Format "minor units" using shop.money_format-like tokens.
  // - Non-zero decimal currencies (USD, HKD, ...):   minor = cents → display cents/100
  // - Zero-decimal currencies   (JPY, VND, ...):     minor = units → display integer
  function formatMoney(minor, moneyFormat, isZeroDecimal) {
    if (isZeroDecimal) {
      var valueNoDec = Math.round(Number(minor) || 0);
      return moneyFormat
        .replace('{{amount_no_decimals}}', valueNoDec)
        .replace('{{ amount_no_decimals }}', valueNoDec)
        // Fallback if theme mistakenly uses {{amount}} for zero-decimal
        .replace('{{amount}}', valueNoDec)
        .replace('{{ amount }}', valueNoDec);
    } else {
      var value = (Number(minor || 0) / 100).toFixed(2);
      var valueNoDec = Math.round(Number(minor || 0) / 100);
      return moneyFormat
        .replace('{{amount}}', value)
        .replace('{{ amount }}', value)
        .replace('{{amount_no_decimals}}', valueNoDec)
        .replace('{{ amount_no_decimals }}', valueNoDec);
    }
  }

  // Ensure .fs-wrap has .fs-note and .fs-bar/__fill
  function ensureStructure($wrap) {
    if (!$wrap.querySelector('.fs-note')) {
      var note = document.createElement('div');
      note.className = 'fs-note';
      note.setAttribute('aria-live', 'polite');
      $wrap.insertAdjacentElement('afterbegin', note);
    }
    if (!$wrap.querySelector('.fs-bar')) {
      var bar = document.createElement('div');
      bar.className = 'fs-bar';
      var fill = document.createElement('span');
      fill.className = 'fs-bar__fill';
      bar.appendChild(fill);
      $wrap.appendChild(bar);
    }
  }

  // Render a single widget (all values are "minor units")
  function renderFS($wrap, thresholdMinor, subtotalMinor, moneyFormat, isZeroDecimal) {
    ensureStructure($wrap);

    if (!thresholdMinor || thresholdMinor <= 0) {
      $wrap.hidden = true; // hide if not configured
      return;
    }
    $wrap.hidden = false;

    var note = $wrap.querySelector('.fs-note');
    var fill = $wrap.querySelector('.fs-bar__fill');

    var subtotal = Math.max(0, Number(subtotalMinor || 0));
    var pct = Math.max(0, Math.min(100, Math.floor((subtotal / thresholdMinor) * 100)));
    if (fill) fill.style.width = pct + '%';

    var textReached  = $wrap.getAttribute('data-fs-text-reached')   || 'You have reached Free Shipping!';
    var textTemplate = $wrap.getAttribute('data-fs-text-template') || 'Add {{ count }} more to enjoy Free Shipping!';

    if (note) {
      if (subtotal >= thresholdMinor) {
        note.textContent = textReached;
      } else {
        var remain = thresholdMinor - subtotal;

        var amountHtml = '<span>' + formatMoney(remain, moneyFormat, isZeroDecimal) + '</span>';

        // hỗ trợ cả {{ count }} và {{count}}
        var out = textTemplate;
        out = out.replace('{{ count }}', amountHtml);
        out = out.replace('{{count}}', amountHtml);

        note.innerHTML = out;
      }
    }

  }


  // Fetch latest cart.json (Shopify: total_price is always in "minor units")
  async function fetchCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!res.ok) throw new Error('cart.js failed');
    return res.json();
  }

  // Process a single .fs-wrap
  function processWrap($wrap, cartJson) {
    var thresholdMinor = Number($wrap.getAttribute('data-fs-threshold') || 0);
    var moneyFormat = $wrap.getAttribute('data-fs-money-format') || '{{amount}}';
    var isZeroDecimal = ($wrap.getAttribute('data-fs-zero-decimal') || 'false') === 'true';

    // Prefer live cart total; fallback to attribute
    var subtotalAttr = Number($wrap.getAttribute('data-fs-subtotal') || 0);
    var subtotalMinor = (cartJson && typeof cartJson.total_price === 'number')
      ? cartJson.total_price
      : subtotalAttr;

    renderFS($wrap, thresholdMinor, subtotalMinor, moneyFormat, isZeroDecimal);
  }

  function renderAllWraps(cartJson) {
    var wraps = document.querySelectorAll('.fs-wrap');
    wraps.forEach(function ($wrap) { processWrap($wrap, cartJson); });
  }

  var _lastCart = null;

  async function refreshAll(cartJson) {
    var wraps = document.querySelectorAll('.fs-wrap');
    if (!wraps.length) return;

    if (!cartJson) {
      try { cartJson = await fetchCart(); } catch (e) { return; }
    }

    _lastCart = cartJson;
    renderAllWraps(cartJson);
  }

  var _rfTimer = null;
  var _pendingCart = undefined;
  function refreshSoon(cartJson) {
    if (cartJson) _pendingCart = cartJson;
    clearTimeout(_rfTimer);
    _rfTimer = setTimeout(function() {
      var cart = _pendingCart;
      _pendingCart = undefined;
      refreshAll(cart);
    }, 300);
  }

  // --- event wiring ----------------------------------------------------------
  var _initialised = false;
  async function initialRefresh() {
    if (_initialised) return;
    _initialised = true;
    await refreshAll();
  }
  document.addEventListener('DOMContentLoaded', initialRefresh);
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) { _initialised = false; initialRefresh(); }
  });
  document.addEventListener('cart:updated', refreshSoon);

  // Patch fetch: read cart data directly from response instead of re-fetching
  (function patchFetch(){
    var _fetch = window.fetch;
    var reCart = /\/cart(\/add|\/change|\/update|\/remove|\/clear)(\.js)?(\?|$)/;
    window.fetch = function() {
      var args = arguments;
      return _fetch.apply(this, args).then(function(res){
        try {
          var url = (args[0] && args[0].toString()) || '';
          if (reCart.test(url)) {
            res.clone().json().then(function(data) {
              if (data && data.items && typeof data.total_price === 'number') {
                refreshSoon(data);
              } else {
                refreshSoon();
              }
            }).catch(function() { refreshSoon(); });
          }
        } catch(e){}
        return res;
      });
    };
  })();

  // Patch XHR: themes using XMLHttpRequest
  (function patchXHR(){
    var Open = XMLHttpRequest.prototype.open;
    var Send = XMLHttpRequest.prototype.send;
    var re = /\/cart(\/add|\/change|\/update|\/remove|\/clear)(\.js)?(\?|$)/;

    XMLHttpRequest.prototype.open = function(method, url) {
      this.__isCartReq = false;
      try {
        var u = (url && url.toString()) || '';
        this.__isCartReq = re.test(u) || (typeof url === 'string' && url.indexOf('/cart') === 0);
      } catch(e){}
      return Open.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function() {
      if (this.__isCartReq) {
        this.addEventListener('loadend', function() {
          try {
            var data = JSON.parse(this.responseText);
            if (data && data.items && typeof data.total_price === 'number') {
              refreshSoon(data);
              return;
            }
          } catch(e){}
          refreshSoon();
        });
      }
      return Send.apply(this, arguments);
    };
  })();

  // Listen to quantity/remove controls (cart page & drawer)
  function bindCartUiListeners() {
    var root = document;
    var qtySelectors = [
      'input[name="updates[]"]',
      'input[name="updates"]',
      '.quantity__input',
      '.cart-quantity-input',
      '.cart-item__quantity input'
    ].join(',');

    // Quantity inputs
    root.addEventListener('change', function(e){
      if (e.target && e.target.matches(qtySelectors)) refreshSoon();
    });

    // Plus/minus buttons
    root.addEventListener('click', function(e){
      var el = e.target;
      if (!el) return;
      if (el.closest && (el.closest('.quantity__button') || el.closest('[data-quantity-button]'))) {
        refreshSoon();
      }
    });

    // Remove buttons/links (common selectors)
    root.addEventListener('click', function(e){
      var t = e.target;
      if (!t) return;

      var isRemove =
        (t.matches && (t.matches('[data-cart-remove]') || t.matches('[data-remove]') || t.matches('.cart-remove'))) ||
        (t.closest && (t.closest('[data-cart-remove]') || t.closest('[data-remove]') || t.closest('.cart-remove')));

      // Anchor patterns: /cart/remove, or /cart/change?quantity=0
      var a = t.closest && t.closest('a[href]');
      if (!isRemove && a) {
        var href = a.getAttribute('href') || '';
        if (/\/cart\/remove(\?|$)/.test(href) || /\/cart\/change(\?|$)/.test(href)) isRemove = true;
      }

      if (isRemove) refreshSoon();
    });

    // Cart forms (submit to /cart)
    var forms = document.querySelectorAll('form[action="/cart"]');
    forms.forEach(function(f){
      f.addEventListener('submit', function(){ refreshSoon(); });
    });
  }
  bindCartUiListeners();

  // Observe DOM for re-inserted .fs-wrap (drawer re-render)
  // Use cached cart data to render immediately — avoids a second fetch/flash
  try {
    var mo = new MutationObserver(function(mutations){
      var newWraps = [];
      mutations.forEach(function(m){
        Array.from(m.addedNodes || []).forEach(function(n){
          if (!n || n.nodeType !== 1) return;
          if (n.matches && n.matches('.fs-wrap')) newWraps.push(n);
          if (n.querySelectorAll) {
            n.querySelectorAll('.fs-wrap').forEach(function(w){ newWraps.push(w); });
          }
        });
      });
      if (!newWraps.length) return;
      if (_lastCart) {
        newWraps.forEach(function($w){ processWrap($w, _lastCart); });
      } else {
        refreshSoon();
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  } catch(e){}

  // Optional: catch Shopify section lifecycle events that may re-render drawer
  document.addEventListener('shopify:section:load', refreshSoon);
  document.addEventListener('shopify:section:reorder', refreshSoon);
  document.addEventListener('shopify:section:select', refreshSoon);
  document.addEventListener('shopify:section:deselect', refreshSoon);
})();